export const UPLOAD_FILE_IMPORT_WIZARD = 'UPLOAD_FILE_IMPORT_WIZARD';
export type UPLOAD_FILE_IMPORT_WIZARD = typeof UPLOAD_FILE_IMPORT_WIZARD;

export interface UploadFileImportWizard {
    type: UPLOAD_FILE_IMPORT_WIZARD;
}

export function uploadFileImportWizardAction(): UploadFileImportWizard {
    return {
        type: UPLOAD_FILE_IMPORT_WIZARD
    };
}
